// extracted by mini-css-extract-plugin
export default {"container":"VrmInput__container-qYt1","fadeOut":"VrmInput__fadeOut-vSLk"};